import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CategoryService } from './../../../../_services/admin/category.service';
import { ProductsService } from './../../../../_services/admin/products.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-editproduct',
  templateUrl: './editproduct.component.html',
  styleUrls: ['./editproduct.component.scss']
})
export class EditproductComponent implements OnInit {

  EditproductForm: FormGroup;
  productCategories: any[] = [];
  fileToUpload: File = null;
  Productlist: any[] = [];

  constructor(private fb: FormBuilder,
    private productService: ProductsService,
    private myTitle: Title,
    private snackBar: MatSnackBar,
    private categoryService: CategoryService,
    private router: Router,
    private route: ActivatedRoute) {

    this.route.params.subscribe(params => {
      if (params['id']) {
        this.EditproductForm = this.fb.group({
          productid: new FormControl(['id'], Validators.required),
          ddlProductCategory: new FormControl('', Validators.required),
          productName: new FormControl('', Validators.required),
          capacity: new FormControl('', Validators.required),
          price: new FormControl(null, null),
          description: new FormControl(null, null),
          chkDisplayOnHome: new FormControl(null, null)
        });
        this.getProductData(params['id']);
        this.EditproductForm.controls['productid'].setValue(params['id']);
      }
    });
  }

  ngOnInit() {
    this.myTitle.setTitle('Edit Product details | ' + environment.commonTitle);
    this.getCategory();
  }

  getCategory() {
    this.categoryService.getAllCategories().subscribe((result) => {
      if (result.data) {
        this.productCategories = result.data;
      }
    });
  }

  getProductData(id: number) {
    this.productService.getproductByid(id).subscribe((data) => {
      if (data.data) {
        const resdata = data.data;
        this.EditproductForm.controls['ddlProductCategory'].setValue(resdata.productCategoryID);
        this.EditproductForm.controls['productName'].setValue(resdata.name);
        this.EditproductForm.controls['capacity'].setValue(resdata.capacity);
        this.EditproductForm.controls['price'].setValue(resdata.price);
        this.EditproductForm.controls['description'].setValue(resdata.description);
        this.EditproductForm.controls['chkDisplayOnHome'].setValue(resdata.isDisplayOnHome);
      }
    });
  }

  updateproduct() {
    if (this.EditproductForm.valid) {
      const objdata = {
        Id: this.EditproductForm.value.productid,
        Name: this.EditproductForm.value.productName,
        ProductCategoryID: this.EditproductForm.value.ddlProductCategory,
        Capacity: this.EditproductForm.value.capacity,
        Price: this.EditproductForm.value.price,
        Description: this.EditproductForm.value.description,
        productImgObj: this.fileToUpload,
        isDisplayOnHome: this.EditproductForm.value.chkDisplayOnHome
      };
      this.productService.editProduct(objdata).subscribe(result => {
        if (result.data) {
          this.openSnackBar('Product updated successfully.', 'Success!');
          // this.router.navigate(['/secure/home/product/products']);
          // this.EditproductForm.reset();
        }
      }, error => {
        this.openSnackBar(error.error, 'Failed to update Product');
      });
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  reditectProductList() {
    this.router.navigate(['/secure/home/product/products']);
  }
}

